import React, { useRef } from "react";
import BarTrack from "./BarTrack";
import useFlipReorder from "../hooks/useFlipReorder";
import { formatCurrency } from "../utils/format";

// Nummer 4 en lager. Die onder het podium plakken leest verwarrend, dus ze
// krijgen hun eigen beurt in beeld.
const RankRest = ({ rest }) => {
  // De balkjes meten hier ten opzichte van de hoogste van déze lijst
  // (nummer 4), niet ten opzichte van nummer 1 - anders blijft er van elk
  // balkje alleen een spikkel over.
  const maxValue = rest.length
    ? Math.max(...rest.map((user) => user.totalPrice || 0))
    : 0;

  // Op naam gekoppeld, niet op plek: haalt iemand een ander in, dan schuiven
  // de twee rijen langs elkaar heen in plaats van hun tekst te ruilen.
  const listRef = useRef(null);
  useFlipReorder(listRef, rest.map((user) => user.name).join("|"));

  return (
    <div className="rank-rest rank-swap" ref={listRef}>
      {rest.map((user, index) => (
        // data-name wijst de animatielaag naar de juiste rij. Twee lagen:
        // de wrapper schuift naar de nieuwe plek, de rij zelf houdt zijn eigen
        // transform vrij voor het oplichten bij een verkoop - op één element
        // vechten die twee animaties om dezelfde property.
        <div className="rank-flip" key={user.name} data-flip-key={user.name}>
          <div data-name={user.name} className="rank-row">
            <div className="no">{index + 4}</div>
            <div className="nm">{user.name}</div>
            <div className="vl">€{formatCurrency(user.totalPrice)}</div>
            <BarTrack value={user.totalPrice} max={maxValue} min={6} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default RankRest;
